import { autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { computedFrom } from "aurelia-binding";
import { Router } from 'aurelia-router';
import { StringHelper } from '../../../../Code/Helpers/StringHelper';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

declare var Swiper;

@autoinject
export class PhotoSliderBaseCustomElement extends BaseCustomElement {

    @bindable({ defaultBindingMode: bindingMode.twoWay }) entityName: string = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) entityId: number = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) columnName: string = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) value: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) tabIndexId: number = -1;
    @bindable({ defaultBindingMode: bindingMode.toView }) documents: Array<any> = null;
    
   
    private element: any = null;
    private swiper: any = null;
    private swiperThumb: any = null;
    private timeRefresh: string = new Date().getTime() + '';

    constructor(element: Element,) {
        super();
        this.element = element;
    }

    bind() {
        //console.log(55555555, 'NumericUpDownBaseCustomElement', this.entityName, this.columnName);
    }

    attached() {
        

          
          this.swiperThumb = new Swiper("." + this.columnName + "Swiper2", {
            loop: false,
      spaceBetween: 10,
      slidesPerView: 2,
      freeMode: false,
      watchSlidesProgress: true,
      grid: {
        fill: 'row',
        rows: 2
      },
            });

            this.swiper = new Swiper("." + this.columnName + "Swiper", {
              loop: false,
              spaceBetween: 10,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              thumbs: {
                swiper: this.swiperThumb,
              }
              
            });
    }
    

    detached() {
        this.swiper.destroy(true, true);
    }
}
